import { useTranslation } from 'react-i18next';

import { OppvarmingBruk } from '../../../../types';

export const useVarmesystemValidation = () => {
  const { t } = useTranslation();
  const validateVarmesystemBruk = (oppvarmingBruk?: OppvarmingBruk) => {
    if (
      !oppvarmingBruk?.romoppvarming &&
      !oppvarmingBruk?.tappevann &&
      !oppvarmingBruk?.ventilasjonVarmebatteri &&
      !oppvarmingBruk?.ukjent
    ) {
      return t('form.oppvarming.common.kjel.oppvarmingBruk.error');
    }
    return true;
  };

  return { validateVarmesystemBruk };
};
